'use client';

import { createTheme } from '@mantine/core';
import base from './base';

const theme = createTheme({
  primaryColor: 'blackroomBlue',
  ...base,
  colors: {
    ...base.colors,

    /* ************************** THEME SPECIFIC COLOR ************************** */

    // Used for hovering primary elements or input backgrounds (ex: menu items)
    blackroomDarkGray: [
      '#edf3f8',
      '#d5d9dc',
      '#bbc0c3',
      '#a1a6aa',
      '#878d92',
      '#6d7379',
      '#545a5f',
      '#3c4144',
      '#23272a',
      '#070e13',
    ],
  },
});

export default theme;
